<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'main-router',
  props: {
  },
  data() {
    return {
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    // this.$destroy()
  },
  methods: {
    init() {
      let mainUrl = this.$store.state.systemInfo.mainUrl;
      // 사용자에게 메인화면 url이 지정되지 않은 경우 기본 대시보드로 이동
      if (!mainUrl || mainUrl === '/') {
        mainUrl = '/main/indexDirector';
      }
      this.$router.push({ path: mainUrl }).catch(() => {});
    },
  }
};
</script>